var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 30,
  viewBox: "0 0 28 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.4328 2.53359H7.76612C6.367 2.53359 5.23279 3.6678 5.23279 5.06693V25.3336C5.23279 26.7327 6.367 27.8669 7.76612 27.8669H20.4328C21.8319 27.8669 22.9661 26.7327 22.9661 25.3336V5.06693C22.9661 3.6678 21.8319 2.53359 20.4328 2.53359Z",
  stroke: "white",
  strokeWidth: 2.56,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1 22.8H14.1128",
  stroke: "white",
  strokeWidth: 2.56,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconPhone;